import DocumentCard from "@/components/DocumentCard";
import RichTextImage from "./RichTextImage";
import { PortableText } from "@portabletext/react";
import {
  Normal,
  Heading2,
  Heading3,
  Heading4,
  Heading5,
  BulletList,
  NumberList,
  DocumentCardsContainer,
  Strong,
  Span,
  Italic,
  Anchor,
} from "./styles";
import Link from "next/link";

export type SimpleRichTextProps = {
  body: Record<string, any>;
  types?: Record<string, any>;
};

const DocumentCards: React.FC<any> = (props) => {
  return (
    <DocumentCardsContainer>
      {props?.files &&
        props?.files?.map((file: any) => (
          <DocumentCard key={file?._key} {...file} />
        ))}
    </DocumentCardsContainer>
  );
};

const SimpleRichText: React.FC<SimpleRichTextProps> = (props) => {
  const { body } = props;
  return (
    <PortableText
      value={body}
      components={{
        block: {
          normal: ({ children }) => <Normal>{children}</Normal>,
          h2: ({ children }) => <Heading2>{children}</Heading2>,
          h3: ({ children }) => <Heading3>{children}</Heading3>,
          h4: ({ children }) => <Heading4>{children}</Heading4>,
          h5: ({ children }) => <Heading5>{children}</Heading5>,
        },
        list: {
          bullet: ({ children }) => <BulletList>{children}</BulletList>,
          number: ({ children }) => <NumberList>{children}</NumberList>,
        },
        marks: {
          red: ({ children }) => <Span $red={true}>{children}</Span>,
          strong: ({ children }) => <Strong>{children}</Strong>,
          em: ({ children }) => <Italic>{children}</Italic>,
          internalLink: ({ children, value }) => {
            if (value.slug) {
              return (
                <Link href={`/${value.slug}`} passHref>
                <Anchor href={`/${value.slug}`}>{children}</Anchor>
                </Link>
              );
            } else {
              console.warn(
                `An internal link hasn't been set. Please check this sentence: "${children}"`
              );
              return <Anchor>{children}</Anchor>;
            }
          },
          externalLink: ({ children, value }) => (
            <Anchor href={value.url.url} target={`${value.url?.blank ? "_blank" : ""}`} rel="noreferrer">
              {children}
            </Anchor>
          ),
          mailLink: ({ children, value }) => (
            <Anchor href={`mailto:${value.url}`} rel="noreferrer">
              {children}
            </Anchor>
          ),
        },
        types: {
          files: (props: Record<string, any>) => (
            <DocumentCards {...props.value} />
          ),
          richTextImage: RichTextImage,
          ...props.types // you can safely spread an undefined value, in fact typescript doesn't complain
        },
      }}
    />
  );
};

export default SimpleRichText;
